import { observer } from 'mobx-react-lite';
import type { JSX, ReactNode } from 'react';
import React from 'react';

import GoalLayout from './GoalLayout';
import GoalV1 from './GoalV1';

interface IProps {
  children?: ReactNode;
}

function Goal({ children }: Readonly<IProps>): JSX.Element {
  return <GoalLayout>{children}</GoalLayout>;
}

Goal.V1 = GoalV1;

export default observer(Goal);
